/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Button, Cell, Grid, HFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { DateField, Form, FormRenderProps, SelectField, TextAreaField } from 'components/form'
import { RadioGroupField } from 'components/form/field/RadioGroupField'
import { FormApi } from 'final-form'
import { metaPath } from 'util/metaPath'

import { AgendamentoReservaModel, MotivoReservaEnum } from '../model'

export const meta = metaPath<AgendamentoReservaModel>()

export interface AgendamentoReservaFormProps {
  onClose(): void
}

export const AgendamentoReservaForm = (props: AgendamentoReservaFormProps) => {
  const { onClose } = props
  const alert = useAlert()

  const handleCancelar = () => onClose()

  const handleSubmit = (values: AgendamentoReservaModel, formApi: FormApi) => {
    // TODO(RNG): salvar dados no banco e definir mensagem do alerta
    alert('success', 'Agendamento de reserva cadastrado com sucesso.')
    setTimeout(formApi.reset)
    onClose()
  }

  const renderForm = (formProps: FormRenderProps<AgendamentoReservaModel>) => {
    const { handleSubmit, values } = formProps

    return (
      <Grid>
        <Cell size={3}>
          <DateField name={meta.data} label='Data' clearable required />
        </Cell>
        <Cell size={9} />

        <Cell size={3}>
          <SelectField<string>
            label='Horário inicial'
            items={['13h00', '13h30', '14h00']}
            itemToString={(item: string) => item}
            name={meta.horarioInicio}
            required
          />
        </Cell>
        <Cell size={3}>
          <SelectField<string>
            label='Horário final'
            items={['13h00', '13h30', '14h00']}
            itemToString={(item: string) => item}
            name={meta.horarioFinal}
            required
          />
        </Cell>
        <Cell size={6} />

        <Cell size={6}>
          <RadioGroupField
            name={meta.motivo}
            label='Motivo'
            lines={2}
            options={[
              { value: MotivoReservaEnum.REUNIAO, label: 'Reunião' },
              { value: MotivoReservaEnum.ATENDIMENTO_EXTERNO, label: 'Atendimento externo' },
              { value: MotivoReservaEnum.ATIVIDADE_COLETIVA, label: 'Atividade coletiva' },
              { value: MotivoReservaEnum.OUTROS, label: 'Outros' },
            ]}
          />
        </Cell>
        {values.motivo === MotivoReservaEnum.OUTROS && (
          <Cell size={6}>
            <TextAreaField label='Especifique o motivo' name={meta.motivoEspecifico} maxLength={100} required />
          </Cell>
        )}

        <Cell size={8}>
          <TextAreaField label='Observações' name={meta.observacoes} maxLength={200} />
        </Cell>
        <Cell size={4} />

        <Cell size={12}>
          <HFlow justifyContent='flex-end'>
            <Button kind='primary' onClick={handleSubmit} size='small'>
              Salvar
            </Button>
            <Button kind='normal' onClick={handleCancelar} size='small'>
              Cancelar
            </Button>
          </HFlow>
        </Cell>
      </Grid>
    )
  }

  return <Form<AgendamentoReservaModel> render={renderForm} onSubmit={handleSubmit} />
}
